import Bao from "./bao-service";
export class UserProfileService {
    Save(key: string, value: string): JQueryPromise<any> {
        return Bao.post("Bao/SetUserProfile", JSON.stringify({ key: key, value: value }), () => {
        });
    }
    Load(key: string): JQueryPromise<string> {
        return Bao.post("Bao/GetUserProfile", JSON.stringify({ key: key }), (result: string) => {
        });
    }
}
export default new UserProfileService();